import React, { useState, useEffect, useRef } from "react";
import { DateTime } from "luxon";
import {
  FaDownload,
  FaEdit,
  FaTrashAlt,
  FaEye,
  FaFileSignature,
} from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { GoStop } from "react-icons/go";
import AlertBox from "./AlertBox";
import { useStateContext } from "../contexts/ContextProvider";
import { apiDeleteLease, apiCreateConversation } from "../services/apiService";
import ViewLeaseModal from "./ViewLeaseModal";
import { removeOldFile } from "../services/firebaseService";

const ActiveLeaseCard = (props) => {
  const { lease, senderId, recipientId, tenantView } = props;
  const {
    user,
    leases,
    setLeases,
    alert,
    handleAlert,
    modal,
    handleModal,
    conversations,
    setConversations,
    transactions,
  } = useStateContext();
  const [showDropdown, setShowDropdown] = useState(false);
  const [statusColor, setStatusColor] = useState("");

  const currentTransactions = transactions.filter(
    (x) => x.leaseId === lease.id
  );

  const modalRef = useRef();

  useEffect(() => {
    getStatus();
    const handler = (e) => {
      if (!modalRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
    // eslint-disable-next-line
  }, [statusColor]);

  const handleDelete = async () => {
    if (lease.status === "active") {
      return;
    } else {
      removeAddendumsFromStorage(lease);
      const response = await apiDeleteLease(lease.id);
      if (response.hasError) {
        // TODO: add error message
        return;
      } else {
        let leasesCopy = leases;
        let newLeases = leasesCopy.toSpliced(
          leasesCopy.findIndex((x) => x.id === lease.id),
          1
        );
        setLeases(newLeases);
      }
    }
  };

  const getStatus = () => {
    if (lease.status === "created") setStatusColor("text-yellow-500");
    if (lease.status === "pending") setStatusColor("text-blue-400");
    if (lease.status === "active") setStatusColor("text-green-500");
  };

  const findOrCreateConvo = async () => {
    // check for exisiting conversation
    const currentConversation = conversations.find(
      (x) =>
        (x.senderId === senderId && x.recipientId === recipientId) ||
        (x.senderId === recipientId && x.recipientId === senderId)
      // (x) =>
      //   (x.senderId === recipientId || x.senderId === senderId) &&
      //   (x.recipientId === recipientId || x.recipientId === senderId)
    );

    // if none exists, create a new one
    if (!currentConversation) {
      const conversationPayload = {
        roomId: lease.roomId,
        senderId,
        recipientId,
        lastMessage: "",
        viewedBySender: true,
        viewedByRecipient: false,
        timeOfLastMessage: "",
        senderDeleted: false,
        recipientDeleted: false,
      };
      const response = await apiCreateConversation(conversationPayload);
      if (response.hasError) {
        //TODO add error message
        return;
      } else {
        setConversations((prevState) => [...prevState, response.data]);
      }
    }
    handleModal("messages");
  };

  const removeAddendumsFromStorage = (lease) => {
    if (lease.rulesAddendum) removeOldFile(lease.rulesAddendum);
    if (lease.disclosuresAddendum) removeOldFile(lease.disclosuresAddendum);
    if (lease.otherAddendum) removeOldFile(lease.otherAddendum);
  };

  return (
    <div className="grid justify-items-center">
      {alert.deleteLease && (
        <AlertBox
          alertType="deleteLease"
          handleAlert={handleAlert}
          alertFunc={handleDelete}
        />
      )}
      {modal.viewLease && (
        <ViewLeaseModal lease={lease} handleModal={handleModal} />
      )}
      <div className="flex gap-x-10 mt-5">
        <div
          className={`cursor-pointer text-blue-500 hover:text-blue-700`}
          onClick={findOrCreateConvo}
        >
          Send Message
        </div>
        {!tenantView && (
          <>
            <div
              className={`${
                currentTransactions
                  ? "text-blue-500 hover:text-blue-700 cursor-pointer"
                  : "text-gray-400 cursor-default"
              }`}
              onClick={
                currentTransactions
                  ? () => handleModal("transactions")
                  : () => {}
              }
              // onClick={
              //   lease.status === "active"
              //     ? () => handleModal("transactions")
              //     : () => {}
              // }
            >
              Transactions
            </div>

            {/* {lease.status === "active" && (
              <div
                className="text-blue-500 hover:text-blue-700"
                onClick={() => {
                  handleModal("endLease");
                }}
              >
                End Lease
              </div>
            )} */}
            {lease.status === "pending" && (
              <div
                className="text-snappily-orange animate-bounce cursor-pointer"
                onClick={() => {
                  handleModal("landlordSignLease");
                }}
              >
                Sign Lease
              </div>
            )}
          </>
        )}
      </div>
      <div className="text-base w-80 border-gray-300 border-2 rounded-xl mt-2 p-5">
        <div className="relative">
          {tenantView &&
            (lease.status === "active" ? (
              <a
                href={lease.leasePdf}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute -right-2 flex items-center text-blue-500 hover:text-blue-700 
                border-1 border-blue-500 rounded-lg px-1 py-.5 cursor-pointer"
              >
                <FaEye className="text-sm" />
                <div className="text-sm pl-1">View</div>
              </a>
            ) : (
              <div
                className="absolute -right-2 flex items-center text-blue-500 hover:text-blue-700 
              border-1 border-blue-500 rounded-lg px-1 py-.5 cursor-pointer"
                onClick={() => {
                  handleModal("viewLease");
                }}
              >
                <FaEye className="text-sm cursor-pointer" />
                <div className="text-sm pl-1">View</div>
              </div>
            ))}
          {!tenantView && (
            <BsThreeDots
              className="absolute right-0 text-black text-xl"
              onClick={() => setShowDropdown(!showDropdown)}
            />
          )}
          <div
            ref={modalRef}
            className={`grid absolute -right-3 top-0 text-black text-lg bg-white border-gray-300 border-1 
          rounded-xl p-4 drop-shadow-xl ${showDropdown ? "" : "hidden"}`}
          >
            {/* {lease.status === "active" && (
              <div
                className="flex items-center gap-x-2 hover:text-gray-500 cursor-pointer"
                onClick={() => {
                  handleModal("viewLease");
                  setShowDropdown(!showDropdown);
                }}
              >
                <FaDownload /> Download
              </div>
            )} */}
            {lease.status === "pending" && (
              <div
                className="flex items-center gap-x-2 text-snappily-orange hover:text-gray-500 cursor-pointer 
                animate-bounce"
                onClick={() => {
                  handleModal("landlordSignLease");
                  setShowDropdown(!showDropdown);
                }}
              >
                <FaFileSignature /> Sign
              </div>
            )}
            {/* <div
              className="flex items-center gap-x-2 hover:text-gray-500 cursor-pointer"
              onClick={() => {
                handleModal("viewLease");
                setShowDropdown(!showDropdown);
              }}
            >
              <FaEye /> View
            </div> */}
            {lease.status === "active" ? (
              <>
                <a
                  href={lease.leasePdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                >
                  <FaEye />
                  View
                </a>
                {/* <a
                  href={lease.leasePdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                  download={`Lease Agreement_${lease.streetAddress}_${lease.leaseStart}.pdf`}
                >
                  <FaDownload /> Download   // requires same orgin url to work
                </a> */}
              </>
            ) : (
              <div
                className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                onClick={() => {
                  handleModal("viewLease");
                }}
              >
                <FaEye />
                View
              </div>
            )}
            {lease.status === "created" && (
              <div
                className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                onClick={() => {
                  handleModal("addRoommate");
                  setShowDropdown(!showDropdown);
                }}
              >
                <FaEdit /> Edit
              </div>
            )}
            {lease.status !== "active" && (
              <div
                className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                onClick={() => {
                  handleAlert("deleteLease");
                  setShowDropdown(!showDropdown);
                }}
              >
                <FaTrashAlt /> Delete
              </div>
            )}
            {lease.status === "active" && (
              <div
                className="flex items-center gap-x-2 hover:text-gray-300 cursor-pointer"
                onClick={() => {
                  if (lease.status === "active") handleModal("endLease");
                  setShowDropdown(!showDropdown);
                }}
              >
                <GoStop /> End Lease
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-center capitalize">
          Status: <span className={`ml-1 ${statusColor}`}> {lease.status}</span>
        </div>
        <div className="flex justify-center capitalize mt-2">
          <div
            className="mr-1"
            // onClick={() => setPage(1)}
          >
            {lease.tenantFirstName}
          </div>
          <div
            className="whitespace-pre-wrap"
            // onClick={() => setPage(2)}
          >
            {lease.tenantMiddleName ? `${lease.tenantMiddleName} ` : ""}
          </div>
          <div
            className=""
            // onClick={() => setPage(3)}
          >
            {lease.tenantFirstName.length +
              (lease.tenantMiddleName ? lease.tenantMiddleName.length : 0) +
              lease.tenantLastName.length >
            25
              ? `${lease.tenantLastName.slice(0, 4)}...`
              : lease.tenantLastName}
          </div>
        </div>
        <div
          className="flex justify-center text-black"
          // onClick={() => console.log("Update Email")}
        >
          {lease.tenantEmail.length > 30
            ? `${lease.tenantEmail.slice(0, 30)}...`
            : lease.tenantEmail}
        </div>
        <div className="flex justify-between mt-5">
          <div>Term:</div>
          <div
            className="capitalize pl-5"
            // onClick={() => setPage(7)}
          >
            {lease.leaseTerm}
          </div>
        </div>
        <div className="flex justify-between">
          <div>Start Date:</div>
          <div
            className="capitalize"
            // onClick={() => setPage(8)}
          >
            {DateTime.fromISO(lease.leaseStart).toFormat("D")}
          </div>
        </div>
        <div className="flex justify-between">
          <div>End Date:</div>
          <div className="capitalize">
            {lease.leaseTerm === "1 month"
              ? "Month-to-month"
              : DateTime.fromISO(lease.leaseEnd).toFormat("D")}
          </div>
        </div>
        <div className="flex justify-between mt-2 capitalize">
          <div>{lease.payPeriod} Rent:</div>
          <div className="flex justify-center">
            ${Intl.NumberFormat().format(lease.rent)}
          </div>
        </div>
        <div className="flex justify-between">
          <div>Security Deposit:</div>
          <div className="flex justify-center">
            ${Intl.NumberFormat().format(lease.securityDep)}
          </div>
        </div>
        {lease.petsAllowed && (
          <div className="flex justify-between">
            <div>Pet Deposit:</div>
            <div className="flex justify-center">
              ${Intl.NumberFormat().format(lease.petDeposit)}
            </div>
          </div>
        )}
        <div className="flex justify-between mt-2">
          {lease.prorateAmount && (
            <>
              <div>
                First {lease.payPeriod === "weekly" ? "Week's" : "Month's"}{" "}
                Pro-rate:
              </div>
              <div className="flex justify-center">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(lease.prorateAmount)}
              </div>
            </>
          )}
        </div>
        <div className="flex justify-between">
          <div>Contributes to Bills:</div>
          <div className="flex justify-center">
            {lease.splitsBills ? "Yes" : "No"}
          </div>
        </div>
        <div className="flex justify-between">
          <div>Collect Late Fees:</div>
          <div className="flex justify-center">
            {lease.paysLateFee ? "Yes" : "No"}
          </div>
        </div>
        {lease.status === "active" && user.defaultView === "landlord" && (
          <div className="flex justify-center mt-5">
            <div
              className="border-1 border-gray-300 rounded-lg 
            text-blue-500 hover:text-blue-700 cursor-pointer p-2"
              onClick={() => {
                handleModal("acceptPayment");
              }}
            >
              Accept Payment
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveLeaseCard;
